import $ from 'jquery';

export function discographySubMenu() {
  $( ".js-openAlbumSubmenu" ).click(function() {
        const elem = $('.js-albumSubmenu');
        elem.css("display", "block");
    });

    $( ".js-closeAlbumSubmenu" ).click(function() {
        const elem = $('.js-albumSubmenu');
        elem.css("display", "none");
    });

}
